import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
import { Icon } from "../icon";
export var Status = React.forwardRef(function Status(_a, ref) {
    var _b;
    var _c = _a.icon, icon = _c === void 0 ? "blank" : _c, _d = _a.size, size = _d === void 0 ? "l" : _d, title = _a.title, description = _a.description, operation = _a.operation, className = _a.className, props = __rest(_a, ["icon", "size", "title", "description", "operation", "className"]);
    var classPrefix = useConfig().classPrefix;
    var isXsSize = size === "xs";
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-status", "size-" + size, className) }, props),
        React.createElement("div", { className: classPrefix + "-status__img" },
            React.createElement(Icon, { type: classNames("status-" + icon, { "size-s": isXsSize }) })),
        React.createElement("div", { className: classPrefix + "-status__content" },
            title && React.createElement("h4", { className: classPrefix + "-status__title" }, title),
            React.createElement("div", { className: classPrefix + "-status__detail" }, description)),
        React.createElement("div", { className: classNames(classPrefix + "-status__operate", (_b = {},
                _b[classPrefix + "-ml-1n"] = isXsSize,
                _b)) }, operation)));
});
Status.displayName = "Status";
//# sourceMappingURL=Status.js.map